/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSwipeRight = createReactComponent("swipe-right", "IconSwipeRight", [
  ["path", { d: "M4 12a4 4 0 1 1 8 0a4 4 0 0 1 -8 0z", key: "svg-0" }],
  ["path", { d: "M12 12h8", key: "svg-1" }],
  ["path", { d: "M17 15l3 -3l-3 -3", key: "svg-2" }]
]);

export { IconSwipeRight as default };
//# sourceMappingURL=IconSwipeRight.js.map
